import { IServiceFactory } from '../../common/types/service-factory';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';
import { FavouriteApiService } from '../services/favourite-api-service';

export class FavouriteApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<FavouriteApiService> {
    public Create(): FavouriteApiService {
        return new FavouriteApiService(this.apiServiceFactory.Create(), this.appConfigService);
    }
}
